<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader> </MoonLoader>
    </div>
    <!-- V-else -->
    <div v-else>
      <BackButton class="u-margin-bottom-small"> </BackButton>

      <div class="row">
        <div class="col">
          <edit-role-form :role="role" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <assigned-users-card :role="role" :company="company" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <assigned-scopes-card :scopes="role.scopes" :role="role" :company="company" />
        </div>
      </div>
    </div>
    <!-- End V-else Part -->
  </div>
</template>

<script>
import axiosAuth from '../../../axiosMain';
import BackButton from '../../../components/buttons/BackButton';
import MoonLoader from '../../../components/svg/SvgLoaderMoon';
import EditRoleForm from './EditRoleForm';
import AssignedUsersCard from './AssignedUsersCard';
import AssignedScopesCard from './AssignedScopesCard';

export default {
  name: 'RightsManagementShow',
  components: {
    MoonLoader,
    BackButton,
    EditRoleForm,
    AssignedUsersCard,
    AssignedScopesCard,
  },
  data: function () {
    return {
      role: '',
      loading: true,
      company: null,
    };
  },
  mounted() {
    this.setLoader();
    this.setCompany();
    this.getRole();
  },
  methods: {
    getRole: function () {
      axiosAuth
        .get('/roles/' + this.$route.params.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.role = response.data.data;
          this.resetLoader();
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
    setLoader: function () {
      this.loading = true;
    },
    resetLoader: function () {
      this.loading = false;
    },
    setCompany() {
      this.company = this.$store.getters.company;
    },
  },
};
</script>

<style scoped></style>
